export default __webpack_public_path__ + "static/media/health-plan.a6096382.png";